import ContentWrapper from 'Component/ContentWrapper';
import { isMobile } from 'Util/Mobile';
import { isCrawler, isSSR } from 'Util/Browser';
import ProductTab from 'Component/ProductTab';

import { ProductTabs as SourceProductTabs } from 'SourceComponent/ProductTabs/ProductTabs.component';

export class ProductTabs extends SourceProductTabs {
    renderTab = (item, i) => {
        const { activeTab } = this.state;

        return (
            <ProductTab
                tabName={ item.name }
                frontTabName={ item.attributeTabName() ? item.attributeTabName() : item.name }
                key={ i }
                onClick={ this.onTabClick }
                isActive={ i === activeTab }
            />
        );
    }

    renderTabs() {
        const { tabs } = this.props;

        if (isMobile.any() || isSSR() || isCrawler()) {
            return this.renderAllTabs();
        }

        return (
            <>
                <ul block="ProductTabs">
                    { tabs.map(this.renderTab) }
                </ul>
                <div className="ProductTabs-ContentWrapper">
                    <div className="ProductTabs-Content">{ this.renderActiveTab() }</div>
                </div>
            </>
        );
    }

    render() {
        const { tabs } = this.props;

        if(tabs.length === 0) {
            return null;
        }

        return (
            <ContentWrapper
              wrapperMix={ { block: 'ProductTabs', elem: 'Wrapper' } }
              label={ __('Product tabs') }
            >
                { this.renderTabs() }
            </ContentWrapper>
        );
    }
}

export default ProductTabs;
